module.exports = __webpack_public_path__ + "img/hm-carousel.fd940752.png";